import axios from "axios"
import { handleHttpException } from "@/http"
import { useHealthStore } from "@/stores/healthStore"
import { useAuthStore } from "./stores/authStore"

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_BASE_API_URL ?? "https://localhost:44339",
  timeout: 10 * 1000, // 10 seconds
  withCredentials: true,
})

axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    const healthStore = useHealthStore()

    if (!error.response && (error.code === "ECONNABORTED" || error.message.includes("Network Error"))) {
      if (!healthStore.isCheckingHealth && healthStore.isBackendReachable) {
        healthStore.checkHealth()
      }
    }
    return handleHttpException(error)
  },
)

const v1 = axios.create({
  baseURL: import.meta.env.VITE_BASE_V1_API_URL ?? "http://localhost:5000",
  withCredentials: true,
})

v1.interceptors.request.use(async (config) => {
  const authStore = useAuthStore()

  const token = await authStore.getAccessToken()

  if (token) {
    config.headers.setAuthorization(`Bearer ${token}`)
  }

  return config
})

v1.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    return handleHttpException(error)
  },
)

export { axiosInstance as axios, v1 }
